import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuOutlined, CameraOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import useBottomBarStore from './mobileBottomBarSlotStore';
import useAuthStore from '../store/authStore';

interface Props {
  right?: React.ReactNode;   // например, кнопка буфера сканов
}

const BAR_HEIGHT = 56;

const MobileBottomBar: React.FC<Props> = ({ right }) => {
  const navigate = useNavigate();
  const { hasPermission } = useAuthStore();
  // Центральная кнопка регистрируется страницей через mobileBottomBarSlotStore.
  const center = useBottomBarStore((s) => s.center);

  // Дефолтный центр — круглая кнопка сканирования (страница сканирования
  // перекрывает слот своей кнопкой рестарта камеры).
  const defaultCenter = hasPermission('marking:write') ? (
    <Button
      type="primary"
      shape="circle"
      size="large"
      icon={<CameraOutlined />}
      onClick={() => navigate('/marking/scan')}
      style={{ width: 52, height: 52, transform: 'translateY(-6px)' }}
      aria-label="Сканирование"
    />
  ) : null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: `calc(${BAR_HEIGHT}px + env(safe-area-inset-bottom, 0px))`,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        background: '#fff',
        borderTop: '1px solid #e8e8e8',
        display: 'flex',
        alignItems: 'stretch',
        zIndex: 1000,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.04)',
      }}
    >
      <button
        type="button"
        onClick={() => navigate('/menu')}
        aria-label="Меню"
        style={{
          flex: 1,
          background: 'transparent',
          border: 'none',
          fontSize: 24,
          cursor: 'pointer',
          color: '#1677ff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <MenuOutlined />
      </button>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {center ?? defaultCenter}
      </div>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {right}
      </div>
    </div>
  );
};

export const MOBILE_BOTTOM_BAR_HEIGHT = BAR_HEIGHT;

export default MobileBottomBar;
